$('.js-view-more').on('click', function(event) {
    let that = this;
    $('.hide-answer').each(function(){        
        if($(this).css('display') == 'block' && $(that).closest('.js-hide-show').find('.hide-answer')[0] != this) {
            $(this).slideToggle();
            
            $(this).closest('.js-view-more').toggleClass('active');
            
            $(this).closest('.js-hide-show').find('.icon-plus-sign').removeClass('hide-icon');
            $(this).closest('.js-hide-show').find('.icon-minus-sign').addClass('hide-icon');
        }
    });
});

$('.js-view-more').on('click', function(event) {
    if($(this).closest('.js-hide-show').find('.icon-plus-sign').hasClass('hide-icon')) {
        $(this).closest('.js-hide-show').find('.icon-plus-sign').removeClass('hide-icon');
        $(this).closest('.js-hide-show').find('.icon-minus-sign').addClass('hide-icon');
    } else {
        $(this).closest('.js-hide-show').find('.icon-plus-sign').addClass('hide-icon');
        $(this).closest('.js-hide-show').find('.icon-minus-sign').removeClass('hide-icon');
    }

    $(this).closest('.js-hide-show').find('.hide-answer').slideToggle();
    $(this).toggleClass('active');
});
